import strips from "shared/assets/img/plotBackgrounds/strips.png";
import stripsWithShop from "shared/assets/img/plotBackgrounds/stripsWithShop-1700.png";
import FinalIconLevel1 from "shared/assets/img/pages/plot/finalIconLevel1.png";
import Outcome from "shared/assets/img/pages/plot/outcomeIcon.png";
import town from "shared/assets/img/plotBackgrounds/town.png";
import money from "shared/assets/img/pages/plot/money.png";
import message from "shared/assets/img/pages/plot/message.png";
import mother from "shared/assets/img/speakers/mother.png";
import father from "shared/assets/img/speakers/father.png";
import boy from "shared/assets/img/speakers/boy.png";
import boyStudent from "shared/assets/img/speakers/boyStudent.png";
import boyStudent2 from "shared/assets/img/speakers/boyStudent2.png";
import robot from "shared/assets/img/speakers/robot.png";
import girl from "shared/assets/img/speakers/girl.png";
import girl2 from "shared/assets/img/speakers/girl2.png";
import girlStudent from "shared/assets/img/speakers/girlStudent.png";
import girlStudent2 from "shared/assets/img/speakers/girlStudent2.png";
import director from "shared/assets/img/speakers/director-tsg.png";
import callAssistant from "shared/assets/img/pages/plot/call_assistant.png";
import merchandiser from "shared/assets/img/pages/plot/merchandiser.png";
import pizzaDelivery from "shared/assets/img/pages/plot/pizza_delivery.png";
import tutor from "shared/assets/img/pages/plot/tutor.png";
import waiter from "shared/assets/img/pages/plot/waiter.png";
import accountant from "shared/assets/img/pages/plot/accountant.png";
import assistant_manager from "shared/assets/img/pages/plot/assistant_manager.png";
import IT_specialist from "shared/assets/img/pages/plot/IT_specialist.png";
import manager from "shared/assets/img/pages/plot/manager.png";
import insurance_head from "shared/assets/img/pages/plot/insurance_head.png";
import senior_frontend from "shared/assets/img/pages/plot/senior_frontend.png";
import purchasing_head from "shared/assets/img/pages/plot/purchasing_head.png";
import own_business from "shared/assets/img/pages/plot/own_business.png";
import DefIcon from "shared/assets/img/pages/plot/defaultIcon.png";
import Phone from "shared/assets/img/pages/plot/phone.png";
import PhoneHalf from "shared/assets/img/pages/plot/phoneHalf.png";
import { APIUser } from "app/api/APITypes";
import { speakerData } from "widgets/PlotSteps/model/api/speakerData";
import { formatNumber } from "shared/lib/utils/utils";

export const plotStepData = (
    stepNumber: number,
    user?: APIUser,
    options?: any
): any => {
    const data: any = {
        1: {
            backButton: true,
            background: "room",
            preloadImg: [mother],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgFull,
                message: `Меня зовут ${user.avatar_name}. Я учусь в школе № 1 города Энска в 8 классе,
                увлекаюсь вопросами экологии и бережного отношения к окружающей среде.
                Сегодня день моего рождения. Мне исполнилось 14 лет.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 2,
                    },
                ],
            },
        },
        2: {
            backButton: true,
            background: "room",
            preloadImg: [girl2, boy],
            needTransaction: true,
            transaction: {
                //present
                name: "Подарок от родителей",
                value: 3000,
                to: "wallet",
                code: "present",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.mother.name,
                speakerImg: speakerData.mother.img,
                message: `Доброе утро, ${user.avatar_name}! С днем рождения! Мы с папой знаем, что у тебя есть цель,
                на которую ты копишь. И для того, чтобы она быстрее стала реальностью, мы решили подарить тебе денежки!
                Распорядись своими деньгами мудро!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 3,
                    },
                ],
            },
        },
        3: {
            backButton: true,
            background: "room",
            preloadImg: [father],
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].img,
                message: `Как круто! 3 000 рублей! Наконец-то я смогу купить то, что давно ${
                    user.avatar === "m" ? "хотел" : "хотела"
                }!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 4,
                    },
                ],
            },
        },
        4: {
            backButton: true,
            background: "room",
            preloadImg: [stripsWithShop, robot],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.father.name,
                speakerImg: speakerData.father.img,
                message:
                    "Самое главное, чтобы это было именно то, чего хочет твоя душа!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 5,
                    },
                ],
            },
        },
        5: {
            backButton: true,
            showShopSection: true,
            background: "stripsWithShop",
            preloadImg: [girl, boy],
            dialog: {
                leftDialog: true,
                speaker: "robot",
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Зайди в наш Магазин. Тут ты найдешь много вкусняшек, а также полезных, классных и интересных вещей.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 6,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 6,
                    },
                ],
            },
        },
        6: {
            backButton: true,
            isButton: true,
            background: "room",
            showProductsSection: true,
            showShopSection: true,
            preloadImg: [town, director],
            isMoneyViewButton: true,
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",

            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 7,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 7,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 7,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 7,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 7,
                },
            },
        },
        7: {
            backButton: true,
            background: "townAuth",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.directorTsg.name,
                speakerImg: speakerData.directorTsg.img,
                message: `Привет, ${user.avatar_name}! Вчера дул сильный ветер, который разнес мусор по всему двору.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 8,
                    },
                ],
            },
        },
        8: {
            backButton: true,
            background: "townAuth",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.directorTsg.name,
                speakerImg: speakerData.directorTsg.img,
                message: `Я ищу ответственных ребят, готовых собрать весь разбросанный мусор до приезда мусоровоза.
                Если справишься в оговоренный срок, заработаешь до 500 рублей. ${
                    user.avatar === "m" ? "Согласен" : "Согласна"
                }?`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 9,
                    },
                ],
            },
        },
        9: {
            backButton: true,
            background: "townAuth",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.directorTsg.name,
                speakerImg: speakerData.directorTsg.img,
                message: `Я ищу ответственных ребят, готовых собрать весь разбросанный мусор до приезда мусоровоза.
                Если справишься в оговоренный срок, заработаешь до 500 рублей. ${
                    user.avatar === "m" ? "Согласен" : "Согласна"
                }?`,
            },
            action: {
                questionView: {
                    question: "Что ответим главе ТСЖ?",
                },
                buttons: [
                    {
                        buttonText: `${
                            user.avatar === "m" ? "Согласен" : "Согласна"
                        }, когда приступать?`,
                        linkOnStep: 10,
                    },
                    {
                        buttonText: "Спасибо, не смогу.",
                        linkOnStep: 11,
                    },
                ],
            },
        },
        10: {
            backButton: true,
            background: "townAuth",
            preloadImg: [girl, boy],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgFull,
                message: `Да, ${
                    user.avatar === "m" ? "согласен" : "согласна"
                }. Когда приступать?`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 12,
                        externalLink: true,
                        linkOnPage: "/fingram-game/site/game",
                        type: "link",
                    },
                ],
            },
        },
        11: {
            backButton: true,
            background: "townAuth",
            preloadImg: [stripsWithShop, robot],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgFull,
                message: "Нет, к сожалению, не смогу.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 12,
                        type: "link",
                    },
                ],
            },
        },
        12: {
            backButton: true,
            background: "stripsWithShop",
            preloadImg: [girl, boy],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Зайди в наш Магазин. Тут ты найдешь много вкусняшек, а также полезных, классных и интересных вещей.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 13,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 13,
                    },
                ],
            },
        },
        13: {
            backButton: true,
            background: "room",
            preloadImg: [robot],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 14,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 14,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 14,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 14,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 14,
                },
            },
        },
        14: {
            backButton: true,
            background: "stripsWithShop",
            showProductsSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `С этого экрана ты сможешь перейти в раздел «Мои финансы»,
                где найдешь финансовые инструменты, которые помогут накопить и приумножить сбережения.
                Многие из них доступны с 18 лет, а вот открыть накопительный счет и оформить к нему дебетовую карту ты можешь уже сейчас!
                Нужно только разрешение родителей.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 15,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 15,
                    },
                ],
            },
        },
        15: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            needFinalSum: true,
            needAllMoney: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 15,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 16,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 15,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 16,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 16,
                },
            },
        },
        16: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Отличный результат!
                Тебе удалось заработать за год ${formatNumber(
                    Number(sessionStorage.getItem("incomeSum"))
                )} рублей, из которых ты ${
                    user.avatar === "m" ? "потратил" : "потратила"
                } ${formatNumber(
                    Number(sessionStorage.getItem("outcomeSum"))
                )} рублей.
                При аналогичных тратах и поступлениях баланс твоего кошелька за 4 года составит ${formatNumber(
                    Number(sessionStorage.getItem("result"))
                )} рублей.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги первого кона",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 17,
                    },
                ],
            },
        },
        17: {
            backButton: true,
            background: "glitters",
            isFinalDisplay: true,
            preloadImg: [robot],
            nextLevel: 2,
            needAllMoney: true,
            action: {
                finalScreen: {
                    speakerImg: speakerData[user.avatar].imgFull,
                    gender: user.avatar,
                    text: `Я ${
                        user.avatar === "m" ? "закончил" : "закончила"
                    } школу!`,
                },
                buttons: [
                    {
                        buttonText: "Завершить уровень",
                        linkOnPage: "/",
                        linkOnStep: 777,
                    },
                ],
            },
        },
        777: {
            background: "room",
            preloadImg: [mother],
            backgrounds: ["level1", "level2"],
            speakerImgs: [
                speakerData[user.avatar].imgFull,
                speakerData[user.avatar].imgStudentFull,
            ],
            needAllMoney: true,
            action: {
                effectOfGrowing: true,
                stepNumber: 18,
            },
        },

        // Уровень 2

        18: {
            backButton: true,
            background: "school",
            preloadImg: [girlStudent, boyStudent],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Поздравляю! Ты ${
                    user.avatar === "m" ? "поступил" : "поступила"
                } в ВУЗ! Со школьной скамьи ты ${
                    user.avatar === "m" ? "смог" : "смогла"
                } принести не только знания,
                    но и накопить ${
                        formatNumber(options?.wallet) ?? 0
                    } рублей!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnPage: "/history",
                        linkOnStep: 20,
                    },
                ],
            },
        },
        19: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Поздравляю! Ты ${
                    user.avatar === "m" ? "поступил" : "поступила"
                } в ВУЗ!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnPage: "/history",
                        linkOnStep: 20,
                    },
                ],
            },
        },
        20: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudent,
                message: `Хочу через месяц сходить с друзьями на концерт любимой группы,
                надо посчитать свои доходы и расходы, чтобы понять, сколько нужно отложить на эту цель.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 21,
                    },
                ],
            },
        },
        21: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudent,
                message: `Сейчас ежемесячно мне помогают родители в размере
                10 000 рублей, еще я получаю стипендию 1 755 рублей, но кажется, что этого недостаточно. Что скажешь, Бот?`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 22,
                    },
                ],
            },
        },
        22: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Все верно. Теперь давай посчитаем расходы: покупка продуктов питания,
                вещей первой необходимости и оплата коммунальных расходов, интернета, сотовой связи в итоге дают тебе 16 242 рубля.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 23,
                    },
                ],
            },
        },
        23: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Разница между расходами и доходами составляет 4 487 рублей.
                Как думаешь, где взять недостающую сумму?`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 24,
                    },
                ],
            },
        },
        24: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudent,
                message: `Верно подмечено. Стипендии и денег от родителей не хватает, нужно найти подработку!
                Итак, ищу в интернете, на какую работу возьмут студента на неполный рабочий день.
                Так-так, посмотрим все доступные варианты!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 25,
                    },
                ],
            },
        },
        25: {
            background: "school",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            action: {
                blockSelection: true,
                title: "Выбери кем ты будешь работать?",
                linkOnStep: 26,
                initialWork: "pizza",
                blocks: [
                    {
                        keyProfession: "pizza",
                        icon: pizzaDelivery,
                        name: "Доставщик пиццы",
                        sum: 220,
                        duties: "развозить пиццу из ресторана по адресам заказчиков",
                    },
                    {
                        keyProfession: "call_center",
                        icon: callAssistant,
                        name: "Менеджер в банке",
                        sum: 210,
                        duties: "отвечать на звонки клиентов Банка",
                    },
                    {
                        keyProfession: "shop",
                        icon: merchandiser,
                        name: "Мерчендайзер в магазин",
                        sum: 200,
                        duties: "контролировать наличие на полках магазина соответствующего товара",
                    },
                    {
                        keyProfession: "tutor",
                        icon: tutor,
                        name: "Репетитор",
                        sum: 210,
                        duties: "обучать детей на дому",
                    },
                    {
                        keyProfession: "waiter",
                        icon: waiter,
                        name: "Официант в кафе",
                        sum: 200,
                        duties: "разносить еду",
                    },
                    {
                        keyProfession: "unemployed",
                        notWork: true,
                        text: "Не работать",
                    },
                ],
            },
        },
        26: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Укажи, сколько часов в день ты сможешь работать. Но не забывай об учебе!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 27,
                    },
                ],
            },
        },
        27: {
            backButton: true,
            background: "roomStudent",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            action: {
                workSchedule: true,
                title: "Выбери график работы",
                linkOnStep: 28,
                speakerImg: speakerData[user.avatar].imgStudentFull,
                workName: {
                    pizza: "Доставщик пиццы",
                    call_center: "Менеджер в банке",
                    shop: "Мерчендайзер в магазин",
                    tutor: "Репетитор",
                    waiter: "Официант в кафе",
                },
                schedules: {
                    pizza: [
                        {
                            scheduleId: 1,
                            hours: 2,
                            paymentPerDay: 440,
                            paymentPerMonth: 8800,
                            paymentPerYear: 105600,
                        },
                        {
                            scheduleId: 2,
                            hours: 3,
                            paymentPerDay: 660,
                            paymentPerMonth: 13200,
                            paymentPerYear: 158400,
                        },
                        {
                            scheduleId: 3,
                            hours: 4,
                            paymentPerDay: 880,
                            paymentPerMonth: 17600,
                            paymentPerYear: 211200,
                        },
                    ],
                    call_center: [
                        {
                            scheduleId: 1,
                            hours: 2,
                            paymentPerDay: 420,
                            paymentPerMonth: 8400,
                            paymentPerYear: 100800,
                        },
                        {
                            scheduleId: 2,
                            hours: 3,
                            paymentPerDay: 630,
                            paymentPerMonth: 12600,
                            paymentPerYear: 151200,
                        },
                        {
                            scheduleId: 3,
                            hours: 4,
                            paymentPerDay: 840,
                            paymentPerMonth: 16800,
                            paymentPerYear: 201200,
                        },
                    ],
                    shop: [
                        {
                            scheduleId: 1,
                            hours: 2,
                            paymentPerDay: 400,
                            paymentPerMonth: 8000,
                            paymentPerYear: 96000,
                        },
                        {
                            scheduleId: 2,
                            hours: 3,
                            paymentPerDay: 600,
                            paymentPerMonth: 12000,
                            paymentPerYear: 144000,
                        },
                        {
                            scheduleId: 3,
                            hours: 4,
                            paymentPerDay: 800,
                            paymentPerMonth: 16000,
                            paymentPerYear: 192000,
                        },
                    ],
                    tutor: [
                        {
                            scheduleId: 1,
                            hours: 2,
                            paymentPerDay: 420,
                            paymentPerMonth: 8400,
                            paymentPerYear: 100800,
                        },
                        {
                            scheduleId: 2,
                            hours: 3,
                            paymentPerDay: 630,
                            paymentPerMonth: 12600,
                            paymentPerYear: 151200,
                        },
                        {
                            scheduleId: 3,
                            hours: 4,
                            paymentPerDay: 840,
                            paymentPerMonth: 16800,
                            paymentPerYear: 201600,
                        },
                    ],
                    waiter: [
                        {
                            scheduleId: 1,
                            hours: 2,
                            paymentPerDay: 400,
                            paymentPerMonth: 8000,
                            paymentPerYear: 96000,
                        },
                        {
                            scheduleId: 2,
                            hours: 3,
                            paymentPerDay: 600,
                            paymentPerMonth: 12000,
                            paymentPerYear: 144000,
                        },
                        {
                            scheduleId: 3,
                            hours: 4,
                            paymentPerDay: 800,
                            paymentPerMonth: 16000,
                            paymentPerYear: 192000,
                        },
                    ],
                },
            },
        },
        28: {
            backButton: true,
            background: "monthPassed",
            needMonthPassed: true,
            transaction: {
                //month
                name: "Оплата ежемесячных расходов",
                value: -16242,
                to: "wallet",
                code: "month",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 29,
                    },
                ],
            },
        },
        29: {
            backButton: true,
            background: "roomStudent",
            needSalary: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ты ${
                    user.avatar === "m" ? "заработал" : "заработала"
                } ${formatNumber(options?.monthIncome)} рублей! И часть
                твоего заработка (16 424 рубля) уходит на оплату обязательных платежей: покупку продуктов питания,
                вещей первой необходимости, оплату коммунальных расходов и т. д.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 30,
                    },
                ],
            },
        },
        30: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Займусь планированием бюджета. Итак, посчитаем: зарплата (${
                    formatNumber(options?.salary) ?? 0
                } руб.),
                помощь родителей (10 000 рублей)... минус оплата обязательных расходов (16 242 руб.).
                У меня остается ${
                    options?.salary
                        ? formatNumber(Number(options?.salary) + 10000 - 16242)
                        : 0
                } руб. в месяц.
                Не очень много, конечно, но на концерт я точно заработаю!`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 31,
                        linkOnPage: "/history",
                        type: "link",
                    },
                ],
            },
        },
        31: {
            backButton: true,
            background: "stripsWithShop",
            showShopSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Заходи в наш Магазин. Только сегодня ты можешь купить телефон своей мечты по самой выгодной цене!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 32,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 32,
                    },
                ],
            },
        },
        32: {
            backButton: true,
            background: "roomStudent",
            showShopSection: true,
            showProductsSection: true,
            preloadImg: [robot],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 33,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 33,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 33,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 33,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 33,
                },
            },
        },
        33: {
            backButton: true,
            background: "stripsWithShop",
            showProductsSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `В разделе «Мои финансы» ты сможешь найти финансовые инструменты,
                которые помогут тебе накопить и приумножить свой доход!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 34,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 34,
                    },
                ],
            },
        },
        34: {
            backButton: true,
            background: "roomStudent",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 35,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 35,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 35,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 35,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 35,
                },
            },
        },
        35: {
            backButton: true,
            background: "roomStudent",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: "Посмотри! Тебе пришло СМС-сообщение.",
            },
            action: {
                smsView: true,
                onlySms: false,
                centerImg: Phone,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 36,
                    },
                ],
            },
        },
        36: {
            backButton: true,
            background: "roomStudent",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            action: {
                smsView: true,
                onlySms: true,
                centerImg: PhoneHalf,
                name: "СМС",
                smsText: `Привет, я нашел крутую тему! Вкладываешь 5 000 рублей, через месяц получаешь
                500 000 рублей!!! Интересно?`,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 37,
                    },
                ],
            },
        },
        37: {
            backButton: true,
            background: "roomStudent",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: message,
                    text:
                        "Согласиться на предложение? \n" +
                        "Вложишь сейчас свои деньги, \n" +
                        "чтобы через полгода получить \n" +
                        "в сто раз больше?",
                },
                buttons: [
                    {
                        needDoScam: true,
                        buttonText: "Вложить всё",
                        linkOnStep: 38,
                    },
                    {
                        buttonText: "Вложить часть",
                        linkOnStep: 39,
                    },
                    {
                        buttonText: "Игнорировать",
                        linkOnStep: 40,
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 40,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 40,
                },
            },
        },
        38: {
            backButton: true,
            background: "roomStudent",
            needAllMoney: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, твои деньги украли мошенники!
                Не стоит доверять сообщениям с незнакомых номеров, обещающих сказочные богатства. Будь внимательнее!
                Ведь теперь ты знаешь, как этому противостоять.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 43,
                    },
                ],
            },
        },
        39: {
            backButton: true,
            background: "roomStudent",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            needAllMoney: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: "Что ответишь?",
            },
            action: {
                dynamicAnswer: true,
                linkOnStep: 44,
            },
        },
        40: {
            backButton: true,
            background: "roomStudent",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ты ${
                    user.avatar === "m" ? "сделал" : "сделала"
                } все верно! С тобой связались мошенники!
                Помни, что заработать за год в 100 раз больше вложенного – нереально!
                Проявление бдительности помогло тебе защитить сбережения! Так держать!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 42,
                    },
                ],
            },
        },
        41: {
            backButton: true,
            background: "roomStudent",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, переданные тобой деньги украли мошенники! Не стоит доверять сообщениям с незнакомых номеров,
                обещающих сказочные богатства. Будь внимательнее! Ведь теперь ты знаешь, как этому противостоять.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 42,
                    },
                ],
            },
        },
        42: {
            backButton: true,
            background: "myFinance",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Хочешь узнать, как еще можно защитить свои сбережения и увеличить свой доход? Перейди на закладку «Мои финансы».",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 45,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Продолжить игру",
                        linkOnStep: 45,
                    },
                ],
            },
        },
        43: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, ты ${
                    user.avatar === "m" ? "потерял" : "потеряла"
                } свои деньги.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 45,
                        linkOnPage: "/",
                        type: "link",
                    },
                ],
            },
        },
        44: {
            backButton: true,
            background: "strips",
            showFinancialSection: true,
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, ты ${
                    user.avatar === "m" ? "потерял" : "потеряла"
                } часть своих денег.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 45,
                        linkOnPage: "/",
                        type: "link",
                    },
                ],
            },
        },
        45: {
            backButton: true,
            background: "townAuth",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.chief.name,
                speakerImg: speakerData.chief.img,
                message:
                    "Наш бизнес процветает. Поступает множество заказов, а свободных рук нет. Можешь помочь? Нужно выйти поработать пару часов. ",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Ответить",
                        linkOnStep: 46,
                    },
                ],
            },
        },
        46: {
            backButton: true,
            background: "townAuth",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.chief.name,
                speakerImg: speakerData.chief.img,
                message:
                    "Наш бизнес процветает. Поступает множество заказов, а свободных рук нет. Можешь помочь? Нужно выйти поработать пару часов. ",
            },
            action: {
                questionView: {
                    question: "Выйти на работу в выходной день?",
                },
                buttons: [
                    {
                        buttonText: "Нет, у меня другие планы",
                        linkOnStep: 48,
                    },
                    {
                        buttonText: `Да, ${
                            user.avatar === "m" ? "согласен" : "согласна"
                        }`,
                        linkOnStep: 47,
                    },
                ],
            },
        },
        47: {
            backButton: true,
            background: "townAuth",
            preloadImg: [girl, boy],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudentFull,
                message: `Да, я ${
                    user.avatar === "m" ? "согласен" : "согласна"
                }.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 49,
                        externalLink: true,
                        linkOnPage: "/fingram-game/site/game",
                        type: "link",
                    },
                ],
            },
        },
        48: {
            backButton: true,
            background: "townAuth",
            preloadImg: [stripsWithShop, robot],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudentFull,
                message: "Спасибо, не смогу",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 49,
                    },
                ],
            },
        },
        49: {
            backButton: true,
            background: "myFinance",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `В разделе «Мои финансы» ты сможешь найти финансовые инструменты,
                которые помогут тебе накопить и приумножить свой доход!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 50,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Продолжить сюжет",
                        linkOnStep: 50,
                    },
                ],
            },
        },
        50: {
            backButton: true,
            background: "roomStudent",
            preloadImg: [robot],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 51,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 51,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 51,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 51,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 51,
                },
            },
        },
        51: {
            backButton: true,
            background: "myShop",
            preloadImg: [girl, boy],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Сегодня в магазине суперакция! Любая техника на 10% дешевле!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 52,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Пропустить",
                        linkOnStep: 52,
                    },
                ],
            },
        },
        52: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            needFinalSum: true,
            needAllMoney: true,
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 52,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 53,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 52,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 53,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 53,
                },
            },
        },
        53: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Отличный результат!
                Тебе удалось заработать за год ${formatNumber(
                    Number(sessionStorage.getItem("incomeSum"))
                )} рублей, из которых ты ${
                    user.avatar === "m" ? "потратил" : "потратилa"
                } ${formatNumber(
                    Number(sessionStorage.getItem("outcomeSum"))
                )} рублей.
                При аналогичных тратах и поступлениях баланс твоего кошелька за 4 года составит ${formatNumber(
                    Number(sessionStorage.getItem("result"))
                )} рублей.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги за уровень",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 55,
                    },
                ],
            },
        },
        54: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, ты все ${
                    user.avatar === "m" ? "потратил" : "потратила"
                }. Нужно научиться не только зарабатывать, но и накапливать, это поможет тебе в будущем.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги второго кона",
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 55,
                    },
                ],
            },
        },
        55: {
            backButton: true,
            background: "glitters",
            isFinalDisplay: true,
            preloadImg: [robot],
            nextLevel: 3,
            needAllMoney: true,
            action: {
                finalScreen: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    gender: user.avatar,
                    text: `Я ${
                        user.avatar === "m" ? "закончил" : "закончила"
                    } ВУЗ!`,
                },
                buttons: [
                    {
                        buttonText: "Завершить уровень",
                        linkOnPage: "/",
                        linkOnStep: 888,
                    },
                ],
            },
        },
        888: {
            background: "room",
            preloadImg: [mother],
            backgrounds: ["level2", "level3"],
            speakerImgs: [
                speakerData[user.avatar].imgStudentFull,
                speakerData[user.avatar].imgStudentFull,
            ],
            needAllMoney: true,
            action: {
                effectOfGrowing: true,
                stepNumber: 56,
            },
        },

        // Уровень 3

        56: {
            backButton: true,
            background: "roomStudent",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Поздравляю! Ты теперь дипломированный специалист, а помимо этого, тебе удалось сформировать
                свои первые сбережения – ${
                    formatNumber(options?.wallet) ?? 0
                } рублей.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnPage: "/history",
                        linkOnStep: 57,
                    },
                ],
            },
        },
        57: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudent,
                message: `Я ${
                    user.avatar === "m" ? "получил" : "получила"
                } хорошую профессию. Пора подумать о самостоятельности и собственном жилье.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 58,
                    },
                ],
            },
        },
        58: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Отличный план! Посмотри, сколько интересных предложений на рынке профессий! Есть из чего выбрать.
                И не забудь, что у тебя есть обязательные ежемесячные расходы (продукты, коммунальные платежи, связь и т. д.).
                Ежемесячно на это уходит 16 242 рубля.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 59,
                    },
                ],
            },
        },
        59: {
            backButton: true,
            background: "school",
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudent,
                message:
                    "Я точно справлюсь! Посмотрим... какую же вакансию выбрать?",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 60,
                    },
                ],
            },
        },
        60: {
            background: "school",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            action: {
                blockSelection: true,
                title: "Выбери кем ты будешь работать?",
                linkOnStep: 61,
                perMonth: true,
                initialWork: "sales_manager",
                blocks: [
                    {
                        keyProfession: "sales_manager",
                        icon: manager,
                        name: "Менеджер по продажам",
                        sum: 40000,
                        duties: "заниматься консультацией и продажей товаров и услуг компании",
                    },
                    {
                        keyProfession: "assistant_manager",
                        icon: assistant_manager,
                        name: "Помощник руководителя",
                        sum: 30000,
                        duties:
                            "ведение документооборота, заключающегося в учете и маршрутизации корреспонденции и иной " +
                            "внутренней документации",
                    },
                    {
                        keyProfession: "accountant",
                        icon: accountant,
                        name: "Бухгалтер",
                        sum: 35000,
                        duties: "отвечать за ведение финансовой отчетности компании",
                    },
                    {
                        keyProfession: "junior_it",
                        icon: IT_specialist,
                        name: "Младший IT-специалист",
                        sum: 40000,
                        duties: "отвечать за решение стандартных IT-задач",
                    },
                ],
            },
        },
        61: {
            backButton: true,
            background: "monthPassed",
            needMonthPassed: true,
            transaction: {
                //month
                name: "Оплата ежемесячных расходов",
                value: -16242,
                to: "wallet",
                code: "month",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 62,
                    },
                ],
            },
        },
        62: {
            backButton: true,
            background: "school",
            needAllMoney: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Тебе удалось заработать ${
                    formatNumber(options?.monthIncome) ?? 0
                } рублей! И часть твоего заработка уходит на оплату обязательных платежей:
                покупку продуктов питания,
                вещей первой необходимости, оплату коммунальных расходов и т. д.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 63,
                    },
                ],
            },
        },
        63: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                message: `Отличный результат! Тебе удалось заработать ${
                    formatNumber(options?.wallet) ?? 0
                } рублей.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 64,
                    },
                ],
            },
        },
        64: {
            backButton: true,
            background: "myShop",
            showShopSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Заходи в Магазин! Новые товары и интересные предложения ждут тебя!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 65,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 65,
                    },
                ],
            },
        },
        65: {
            backButton: true,
            background: "room",
            showShopSection: true,
            showProductsSection: true,
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 66,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 66,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 66,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 66,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 66,
                },
            },
        },
        66: {
            backButton: true,
            background: "myFinance",
            showProductsSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "В разделе «Мои финансы» ты найдешь полезные финансовые инструменты, которые помогают не только копить, но и защищать свои деньги!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 67,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 67,
                    },
                ],
            },
        },
        67: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 68,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 68,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 68,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 68,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 68,
                },
            },
        },
        68: {
            backButton: true,
            background: "hospitalWard",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //heal
                name: "Оплата лечения",
                value: -10000,
                to: "wallet",
                ignore: 1,
                code: "heal",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ты ${
                    user.avatar === "m" ? "попал" : "попала"
                } в больницу. Придется пропустить работу и заплатить за лечение! Выздоравливай!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 69,
                    },
                ],
            },
        },
        69: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["dms", "nsj"],
            hasPolicyButton: 70,
            noPolicyButton: 71,
            transaction: {
                //heal_back
                name: "Возврат за лечение",
                value: 10000,
                to: "wallet",
                ignore: 1,
                code: "heal_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message:
                    "Покупка лекарств и оплата лечения обошлись мне в кругленькую сумму 10 000 рублей.",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 70,
                    },
                ],
            },
        },
        70: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Как здорово, что я ${
                    user.avatar === "m" ? "позаботился" : "позаботилась"
                } о страховке заранее. Теперь мне не придется тратить свои деньги`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 72,
                    },
                ],
            },
        },
        71: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Как жаль, что я не ${
                    user.avatar === "m" ? "позаботился" : "позаботилась"
                } о страховке заранее! Надо зайти в «Мои финансы» и посмотреть, что там есть!`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 72,
                    },
                ],
            },
        },
        72: {
            backButton: true,
            background: "office",
            // preloadImg: [father],
            dialog: {
                leftDialog: true,
                speakerName: "Смс-сообщение начальнику",
                speakerImg: speakerData[user.avatar].imgStudent,
                message: `Шеф, добрый день! Важная новость! Регулятор выпустил новые требования к нашему бизнесу,
                требуется поменять большую часть внутренних документов.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 73,
                    },
                ],
            },
        },
        73: {
            backButton: true,
            background: "office",
            // preloadImg: [father],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.chief.name,
                speakerImg: speakerData.chief.img,
                message: `Добрый день, ${user.avatar_name}! Ты ${
                    user.avatar === "m" ? "прав" : "права"
                }, изменения нужно внести как можно скорее. Пожалуйста,
                выйди на работу в свой выходной день, напиши документы в своей части. Твой выход будет оплачен в двойном размере.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 74,
                    },
                ],
            },
        },
        74: {
            backButton: true,
            background: "office",
            // preloadImg: [father],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.chief.name,
                speakerImg: speakerData.chief.img,
                message:
                    "Если не справишься, то можешь ничего не заработать за этот день!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 75,
                    },
                ],
            },
        },
        75: {
            backButton: true,
            background: "office",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.chief.name,
                speakerImg: speakerData.chief.img,
                message:
                    "Если не справишься, то можешь ничего не заработать за этот день!",
            },
            action: {
                questionView: {
                    question: "Выйти на работу в выходной день?",
                },
                buttons: [
                    {
                        buttonText: "Проведу выходные с друзьями",
                        linkOnStep: 77,
                    },
                    {
                        buttonText: "Закрыть все срочные задачи",
                        linkOnStep: 76,
                    },
                ],
            },
        },
        76: {
            backButton: true,
            background: "office",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            // preloadImg: [girl, boy],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudentFull,
                message: "Да, надо закрыть все срочные задачи.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 78,
                        externalLink: true,
                        linkOnPage: "/fingram-game/site/game",
                        type: "link",
                    },
                ],
            },
        },
        77: {
            backButton: true,
            background: "office",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            // preloadImg: [stripsWithShop, robot],
            dialog: {
                centerDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudentFull,
                message: "Нет, лучше проведу выходные с друзьями.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 78,
                    },
                ],
            },
        },
        78: {
            backButton: true,
            background: "myFinance",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "В разделе «Мои финансы» ты сможешь найти финансовые инструменты, которые помогут тебе накопить и приумножить свой доход!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 79,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Продолжить сюжет",
                        linkOnStep: 79,
                    },
                ],
            },
        },
        79: {
            backButton: true,
            background: "office",
            preloadImg: [robot],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 80,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 80,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 80,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 80,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 80,
                },
            },
        },
        80: {
            backButton: true,
            background: "myShop",
            preloadImg: [girl, boy],
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Заходи в наш Магазин, сегодня проходит акция – распродажа элитных вещей со скидкой 50%.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 81,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Пропустить",
                        linkOnStep: 81,
                    },
                ],
            },
        },
        81: {
            backButton: true,
            background: "office",
            // preloadImg: [strips, girl, boy],
            needRandomInsuranceCase: true,
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            events: {
                1: {
                    name: "accident",
                    stepNumber: 82,
                },
                2: {
                    name: "flood",
                    stepNumber: 83,
                },
                3: {
                    name: "disease",
                    stepNumber: 84,
                },
            },
            eventsNsj: {
                1: {
                    name: "accident",
                    stepNumber: 82,
                },
                2: {
                    name: "flood",
                    stepNumber: 83,
                },
                3: {
                    name: "disease",
                    stepNumber: 84,
                },
                4: {
                    name: "nsj",
                    stepNumber: 85,
                },
            },
            eventsDsj: {
                1: {
                    name: "accident",
                    stepNumber: 82,
                },
                2: {
                    name: "flood",
                    stepNumber: 83,
                },
                3: {
                    name: "disease",
                    stepNumber: 84,
                },
                4: {
                    name: "nsj",
                    stepNumber: 85,
                },
            },
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 82,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 82,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 82,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 82,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 82,
                },
            },
        },
        82: {
            backButton: true,
            background: "accident",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //car_accident
                name: "Авария",
                value: -50000,
                to: "wallet",
                ignore: 1,
                code: "car_accident",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Произошло ДТП. Ты ${
                    user.avatar === "m" ? "получил" : "получила"
                } травму. Если у тебя есть страховка от несчастного случая,
                ДМС либо НСЖ, то расходы на лечение возместит страховая компания.
                А если ты не ${
                    user.avatar === "m" ? "застрахован" : "застрахована"
                }, то расходы в размере 50 000 рублей тебе придется оплатить самостоятельно.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 86,
                    },
                ],
            },
        },
        83: {
            backButton: true,
            background: "flood",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //apartments_repair
                name: "Ремонт квартиры",
                value: -100000,
                to: "wallet",
                ignore: 1,
                code: "apartments_repair",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ой-ой! Это настоящий потоп! Придется делать ремонт в квартире соседей снизу.
                А еще в твоей квартире пострадала дорогая техника. Если у тебя есть страхование имущества и гражданской ответственности,
                твой бюджет не пострадает. В противном случае придется заплатить 100 000 рублей из своего кармана.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 87,
                    },
                ],
            },
        },
        84: {
            backButton: true,
            background: "disease",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //hospital
                name: "Лечение в больнице",
                value: -120000,
                to: "wallet",
                ignore: 1,
                code: "hospital",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ты серьезно ${
                    user.avatar === "m" ? "заболел" : "заболела"
                }, требуется дорогостоящее лечение! Если у тебя есть добровольное медицинское страхование (ДМС) либо  НСЖ,
                то расходы на лечение возместит страховая компания. А если ты не ${
                    user.avatar === "m" ? "застрахован" : "застрахована"
                },
                то расходы в размере 120 000 рублей тебе придется оплатить самостоятельно.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 88,
                    },
                ],
            },
        },
        85: {
            backButton: true,
            background: "roomStudent",
            needUseInsurance: true,
            insuranceKey: "nsj",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `С днем рождения! Тебе исполнилось 35!
                У тебя был заключен договор накопительного страхования жизни (НСЖ) сроком дожития до этой даты!
                Страховая компания выплачивает тебе 100 000 рублей.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 89,
                    },
                ],
            },
        },

        // 85 для дожития по НСЖ

        86: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["dms", "nsj", "sjz"],
            hasPolicyButton: 93,
            noPolicyButton: 94,
            transaction: {
                //car_accident_back
                name: "Возврат за травму в ДТП",
                value: 50000,
                to: "wallet",
                ignore: 1,
                code: "car_accident_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Лечение травмы после аварии обошлось в круглую сумму 50 000 руб",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 99,
                    },
                ],
            },
        },
        87: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["property_insurance"],
            hasPolicyButton: 93,
            noPolicyButton: 94,
            transaction: {
                //apartments_repair_back
                name: "Возврат за ремонт квартиры",
                value: 100000,
                to: "wallet",
                ignore: 1,
                code: "apartments_repair_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: "Ремонт квартиры обошелся в круглую сумму 100 000 руб",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 99,
                    },
                ],
            },
        },
        88: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["dms", "nsj"],
            hasPolicyButton: 93,
            noPolicyButton: 94,
            transaction: {
                //hospital_back
                name: "Возврат за лечение в больнице",
                value: 120000,
                to: "wallet",
                ignore: 1,
                code: "hospital_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Лечение в больнице вылилось в круглую сумму 120 000 руб",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 99,
                    },
                ],
            },
        },
        89: {
            backButton: true,
            background: "roomStudent",
            needAllMoney: true,
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgStudent,
                message:
                    "Здорово! Теперь у меня есть первоначальный взнос на ипотеку! Оказалось, что страховаться по НСЖ выгодно!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 90,
                    },
                ],
            },
        },
        90: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Как приятно получать доход! Страховая компания выплатила мне 100 000 рублей! Можно подумать об оформлении еще одного договора НСЖ.",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 95,
                    },
                ],
            },
        },

        // 89, 90, 91, 92 для шагов при выпадании дожития

        93: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Как здорово, что я ${
                    user.avatar === "m" ? "позаботился" : "позаботилась"
                } о страховке заранее. Теперь мне не придется тратить свои деньги`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 95,
                    },
                ],
            },
        },
        94: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Как жаль, что я не ${
                    user.avatar === "m" ? "позаботился" : "позаботилась"
                } о страховке заранее! Надо зайти в «Мои финансы» и посмотреть, что там есть!`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 95,
                    },
                ],
            },
        },
        95: {
            backButton: true,
            background: "myShop",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Заходи в магазин! Новые товары и интересные предложения ждут тебя!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 96,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 96,
                    },
                ],
            },
        },
        96: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 97,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 97,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 97,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 97,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 97,
                },
            },
        },
        97: {
            backButton: true,
            background: "myFinance",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "В разделе «Мои финансы» ты сможешь найти финансовые инструменты, которые помогут тебе накопить и приумножить свой доход!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 98,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 98,
                    },
                ],
            },
        },
        98: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            needFinalSum: true,
            needAllMoney: true,
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 99,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 99,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 99,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 99,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 99,
                },
            },
        },
        99: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Отличный результат!
                Тебе удалось заработать за год ${formatNumber(
                    Number(sessionStorage.getItem("incomeSum"))
                )} рублей, из которых ты ${
                    user.avatar === "m" ? "потратил" : "потратила"
                } ${formatNumber(
                    Number(sessionStorage.getItem("outcomeSum"))
                )} рублей.
                При аналогичных тратах и поступлениях баланс твоего кошелька за 4 года составит ${formatNumber(
                    Number(sessionStorage.getItem("result"))
                )} рублей.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги за уровень",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 101,
                    },
                ],
            },
        },
        100: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, ты все ${
                    user.avatar === "m" ? "потратил" : "потратила"
                }. Нужно научиться не только зарабатывать, но и накапливать, это поможет тебе в будущем.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги второго кона",
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 101,
                    },
                ],
            },
        },
        101: {
            backButton: true,
            background: "glitters",
            isFinalDisplay: true,
            preloadImg: [robot],
            nextLevel: 4,
            needAllMoney: true,
            action: {
                finalScreen: {
                    speakerImg: speakerData[user.avatar].imgStudentFull,
                    gender: user.avatar,
                    text: `Я ${
                        user.avatar === "m" ? "стал" : "стала"
                    } профессионалом своего дела!`,
                },
                buttons: [
                    {
                        buttonText: "Завершить уровень",
                        linkOnPage: "/",
                        linkOnStep: 999,
                    },
                ],
            },
        },
        999: {
            background: "room",
            preloadImg: [mother],
            backgrounds: ["level3", "level4"],
            speakerImgs: [
                speakerData[user.avatar].imgStudentFull,
                speakerData[user.avatar].imgAdultFull,
            ],
            needAllMoney: true,
            action: {
                effectOfGrowing: true,
                stepNumber: 102,
            },
        },

        // Уровень 4

        102: {
            backButton: true,
            background: "roomStudent",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Поздравляю! Ты ${
                    user.avatar === "m" ? "стал" : "стала"
                } профессионалом своего дела и ${
                    user.avatar === "m" ? "смог" : "смогла"
                } накопить достойный капитал ${
                    formatNumber(options?.wallet) ?? 0
                } рублей! Продолжай в том же духе!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnPage: "/history",
                        linkOnStep: 104,
                    },
                ],
            },
        },
        103: {
            backButton: true,
            background: "roomStudent",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Поздравляю! Ты ${
                    user.avatar === "m" ? "стал" : "стала"
                } профессионалом своего дела! Пришло время задуматься о накоплениях и финансовой безопасности.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnPage: "/history",
                        linkOnStep: 104,
                    },
                ],
            },
        },
        104: {
            backButton: true,
            background: "apartment",
            dialog: {
                leftDialog: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData[user.avatar].imgAdult,
                message: `В будущем хочу открыть свое дело, а для этого требуется стартовый капитал.
                Нужно найти работу с более высокой зарплатой, а мой многолетний опыт и профессионализм помогут мне в этом!`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 105,
                    },
                ],
            },
        },
        105: {
            background: "apartment",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            action: {
                blockSelection: true,
                title: "Выбери кем ты будешь работать?",
                linkOnStep: 106,
                perMonth: true,
                initialWork: "insurance_head",
                blocks: [
                    {
                        keyProfession: "insurance_head",
                        icon: insurance_head,
                        name: "Руководитель направления по разработке страховых продуктов в крупном страховщике",
                        sum: 70000,
                        duties: "ведение проектов по разработке новых страховых продуктов и по доработке действующих продуктов компании",
                    },
                    {
                        keyProfession: "senior_frontend",
                        icon: senior_frontend,
                        name: "Главный специалист по Front-End разработке (Senior Front-End Developer)",
                        sum: 70000,
                        duties: "разработка пользовательского интерфейса",
                    },
                    {
                        keyProfession: "purchasing_head",
                        icon: purchasing_head,
                        name: "Начальник отдела закупок в крупной розничной сети",
                        sum: 70000,
                        duties:
                            "организация и личное руководство закупками товара по всему товарному ассортименту; " +
                            "формирование ассортимента, определение объемов; обеспечение максимальной " +
                            "конкурентоспособности цен и условий на закупаемую продукцию",
                    },
                    {
                        keyProfession: "own_business",
                        icon: own_business,
                        name: "открыть свой бизнес",
                        sum: 70000,
                        duties: "",
                    },
                ],
            },
        },
        106: {
            backButton: true,
            background: "monthPassed",
            needMonthPassed: true,
            transaction: {
                name: "Оплата ежемесячных расходов",
                value: -16242,
                to: "wallet",
                code: "month",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 107,
                    },
                ],
            },
        },
        107: {
            backButton: true,
            background: "apartment",
            needAllMoney: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ты ${
                    user.avatar === "m" ? "стал" : "стала"
                } хорошо зарабатывать! Твой доход составил ${formatNumber(
                    options?.monthIncome
                )} рублей! Часть заработка уходит на оплату обязательных расходов:
                покупку продуктов питания, вещей первой необходимости, оплату коммунальных расходов и т. д.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 108,
                    },
                ],
            },
        },
        108: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                message: `Отличный результат! Тебе удалось заработать ${
                    formatNumber(options?.wallet) ?? 0
                } рублей.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 109,
                    },
                ],
            },
        },
        109: {
            backButton: true,
            background: "myShop",
            showShopSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "У нас в Магазине ты найдешь самые красивые ювелирные украшения в городе!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 110,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 110,
                    },
                ],
            },
        },
        110: {
            backButton: true,
            background: "room",
            showShopSection: true,
            showProductsSection: true,
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 111,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 111,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 111,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 111,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 111,
                },
            },
        },
        111: {
            backButton: true,
            background: "myFinance",
            showProductsSection: true,
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "В разделе «Мои финансы» появился новый инвестиционный продукт, узнай подробности.",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 112,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 112,
                    },
                ],
            },
        },
        112: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 113,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 113,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 113,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 113,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 113,
                },
            },
        },
        113: {
            backButton: true,
            background: "townAuth",
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            needRandomInsuranceCase: true,
            events: {
                1: {
                    name: "accident",
                    stepNumber: 115,
                },
                2: {
                    name: "flood",
                    stepNumber: 116,
                },
                3: {
                    name: "disease",
                    stepNumber: 117,
                },
            },
            eventsNsj: {
                1: {
                    name: "accident",
                    stepNumber: 115,
                },
                2: {
                    name: "flood",
                    stepNumber: 116,
                },
                3: {
                    name: "disease",
                    stepNumber: 117,
                },
                4: {
                    name: "nsj",
                    stepNumber: 118,
                },
            },
            eventsDsj: {
                1: {
                    name: "accident",
                    stepNumber: 115,
                },
                2: {
                    name: "flood",
                    stepNumber: 116,
                },
                3: {
                    name: "disease",
                    stepNumber: 117,
                },
                4: {
                    name: "dsj",
                    stepNumber: 119,
                },
            },
            eventsNsjDsj: {
                1: {
                    name: "accident",
                    stepNumber: 115,
                },
                2: {
                    name: "flood",
                    stepNumber: 116,
                },
                3: {
                    name: "disease",
                    stepNumber: 117,
                },
                4: {
                    name: "nsj",
                    stepNumber: 118,
                },
                5: {
                    name: "dsj",
                    stepNumber: 119,
                },
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: "Внимание! Страховой случай!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 115,
                        externalLink: true,
                        linkOnPage: "/fingram-game/site/game?plot=true",
                        type: "link",
                    },
                ],
            },
        },
        // 114: {
        //     backButton: true,
        //     background: "shooterGame",
        //     overlay:
        //         "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
        //     needRandomInsuranceCase: true,
        //     events: {
        //         1: {
        //             name: "accident",
        //             stepNumber: 115,
        //         },
        //         2: {
        //             name: "flood",
        //             stepNumber: 116,
        //         },
        //         3: {
        //             name: "disease",
        //             stepNumber: 117,
        //         },
        //     },
        //     eventsNsj: {
        //         1: {
        //             name: "accident",
        //             stepNumber: 115,
        //         },
        //         2: {
        //             name: "flood",
        //             stepNumber: 116,
        //         },
        //         3: {
        //             name: "disease",
        //             stepNumber: 117,
        //         },
        //         4: {
        //             name: "nsj",
        //             stepNumber: 118,
        //         },
        //     },
        //     eventsDsj: {
        //         1: {
        //             name: "accident",
        //             stepNumber: 115,
        //         },
        //         2: {
        //             name: "flood",
        //             stepNumber: 116,
        //         },
        //         3: {
        //             name: "disease",
        //             stepNumber: 117,
        //         },
        //         4: {
        //             name: "dsj",
        //             stepNumber: 119,
        //         },
        //     },
        //     eventsNsjDsj: {
        //         1: {
        //             name: "accident",
        //             stepNumber: 115,
        //         },
        //         2: {
        //             name: "flood",
        //             stepNumber: 116,
        //         },
        //         3: {
        //             name: "disease",
        //             stepNumber: 117,
        //         },
        //         4: {
        //             name: "nsj",
        //             stepNumber: 118,
        //         },
        //         5: {
        //             name: "dsj",
        //             stepNumber: 119,
        //         },
        //     },
        //     dialog: {
        //         leftDialog: true,
        //         speakerName: speakerData.robot.name,
        //         speakerImg: speakerData.robot.img,
        //         message:
        //             "Вы в зоне повышенного риска. Вам надо в течение 1,5 минут отбиваться от страховых рисков. " +
        //             "Если вы справитесь, то с вами ничего не произойдет, если нет – то, надеюсь, у вас есть, страховка. Удачи!",
        //     },
        //     action: {
        //         buttonsView: true,
        //         buttons: [
        //             {
        //                 buttonText: "Далее",
        //                 linkOnStep: 115,
        //                 externalLink: true,
        //                 linkOnPage: "/fingram-game/site/game",
        //                 type: "link",
        //             },
        //         ],
        //     },
        // },
        115: {
            backButton: true,
            background: "accident",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //car_accident
                name: "Авария",
                value: -50000,
                to: "wallet",
                ignore: 1,
                code: "car_accident",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Произошло ДТП. Ты ${
                    user.avatar === "m" ? "получил" : "получила"
                } травму. Если у тебя есть страховка от несчастного случая,
                ДМС либо НСЖ, то расходы на лечение возместит страховая компания.
                А если ты не ${
                    user.avatar === "m" ? "застрахован" : "застрахована"
                }, то расходы в размере 50 000 рублей тебе придется оплатить самостоятельно.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 120,
                    },
                ],
            },
        },
        116: {
            backButton: true,
            background: "flood",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //apartments_repair
                name: "Ремонт квартиры",
                value: -100000,
                to: "wallet",
                ignore: 1,
                code: "apartments_repair",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ой-ой! Это настоящий потоп! Придется делать ремонт в квартире соседей снизу.
                 А еще в твоей квартире пострадала дорогая техника. Если у тебя есть страхование имущества и гражданской ответственности,
                 то бюджет не пострадает. В противном случае придется заплатить 100 000 рублей из своего кармана.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 121,
                    },
                ],
            },
        },
        117: {
            backButton: true,
            background: "disease",
            needAllMoney: true,
            needTransaction: true,
            transaction: {
                //hospital
                name: "Лечение в больнице",
                value: -120000,
                to: "wallet",
                ignore: 1,
                code: "hospital",
            },
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Ты серьезно ${
                    user.avatar === "m" ? "заболел" : "заболела"
                }, требуется дорогостоящее лечение!
                Если у тебя есть добровольное медицинское страхование (ДМС) либо НСЖ,
                то расходы на лечение возместит страховая компания. А если ты не ${
                    user.avatar === "m" ? "застрахован" : "застрахована"
                },
                то расходы в размере 120 000 рублей тебе придется оплатить самостоятельно.`,
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 122,
                    },
                ],
            },
        },

        // 118, 119 для дожития

        120: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["dms", "nsj", "sjz"],
            hasPolicyButton: 127,
            noPolicyButton: 128,
            transaction: {
                //car_accident_back
                name: "Возврат за травму в ДТП",
                value: 50000,
                to: "wallet",
                ignore: 1,
                code: "car_accident_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: "Лечение обошлось в круглую сумму 50 000 руб",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 128,
                    },
                ],
            },
        },
        121: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["property_insurance"],
            hasPolicyButton: 127,
            noPolicyButton: 128,
            transaction: {
                //apartments_repair_back
                name: "Возврат за ремонт квартиры",
                value: 100000,
                to: "wallet",
                ignore: 1,
                code: "apartments_repair_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: "Ремонт квартиры обошелся в круглую сумму 100 000 руб",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 128,
                    },
                ],
            },
        },
        122: {
            backButton: true,
            background: "strips",
            needAllMoney: true,
            needCheckPolicy: true,
            policyName: ["dms", "nsj"],
            hasPolicyButton: 127,
            noPolicyButton: 128,
            transaction: {
                //hospital_back
                name: "Возврат за лечение в больнице",
                value: 120000,
                to: "wallet",
                ignore: 1,
                code: "hospital_back",
            },
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Лечение в больнице вылилось в круглую сумму 120 000 руб",
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 128,
                    },
                ],
            },
        },

        // 123, 124, 125, 126 экраны для дожитий

        127: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Как здорово, что я ${
                    user.avatar === "m" ? "позаботился" : "позаботилась"
                } о страховке заранее. Теперь мне не придется тратить свои деньги`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 129,
                    },
                ],
            },
        },
        128: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: user.avatar_name,
                speakerImg: speakerData.robot.img,
                message: `Как жаль, что я не ${
                    user.avatar === "m" ? "позаботился" : "позаботилась"
                } о страховке заранее! Надо зайти в «Мои финансы» и посмотреть, что там есть!`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: Outcome,
                    descriptionText: "Перерасчет средств",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 129,
                    },
                ],
            },
        },
        129: {
            backButton: true,
            background: "myShop",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "Заходи в Магазин! Новые товары и интересные предложения ждут тебя!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в Магазин",
                        linkOnStep: 130,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 130,
                    },
                ],
            },
        },
        130: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 131,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 131,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 131,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 131,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 131,
                },
            },
        },
        131: {
            backButton: true,
            background: "myFinance",
            dialog: {
                leftDialog: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message:
                    "В разделе «Мои финансы» ты сможешь найти финансовые инструменты, которые помогут тебе накопить и приумножить свой доход!",
            },
            action: {
                buttonsView: true,
                buttons: [
                    {
                        buttonText: "Зайти в «Мои финансы»",
                        linkOnStep: 132,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        linkOnStep: 132,
                    },
                ],
            },
        },
        132: {
            backButton: true,
            background: "room",
            preloadImg: [strips, girl, boy],
            needFinalSum: true,
            needAllMoney: true,
            overlay:
                "linear-gradient(108deg, rgba(15, 167, 223, 0.50) 3.24%, rgba(61, 187, 110, 0.50) 55.06%, rgba(142, 245, 11, 0.50) 91.81%)",
            isMoneyViewButton: true,
            action: {
                moneyView: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    img: money,
                    text: "Как ты поступишь с имеющимися деньгами?",
                },
                buttons: [
                    {
                        buttonText: "Потратить",
                        linkOnStep: 133,
                        linkOnPage: "/shop",
                        type: "link",
                    },
                    {
                        buttonText: "Ничего не делать",
                        linkOnStep: 133,
                    },
                    {
                        buttonText: "Вложить",
                        linkOnStep: 133,
                        linkOnPage: "/finance",
                        type: "link",
                    },
                    {
                        buttonText: "Далее",
                        isMobButton: true,
                        linkOnStep: 133,
                    },
                ],
                extraButton: {
                    buttonText: "Далее",
                    isMobButton: true,
                    linkOnStep: 133,
                },
            },
        },
        133: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `Отличный результат!
                Тебе удалось заработать за год ${formatNumber(
                    Number(sessionStorage.getItem("incomeSum"))
                )} рублей, из которых ты потратил ${formatNumber(
                    Number(sessionStorage.getItem("outcomeSum"))
                )} рублей.
                При аналогичных тратах и поступлениях баланс твоего кошелька за 4 года составит ${formatNumber(
                    Number(sessionStorage.getItem("result"))
                )} рублей.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги игры",
                    value: options?.wallet,
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 135,
                    },
                ],
            },
        },
        134: {
            backButton: true,
            background: "strips",
            dialog: {
                leftDialog: true,
                hiddenSpeaker: true,
                speakerName: speakerData.robot.name,
                speakerImg: speakerData.robot.img,
                message: `К сожалению, ты все ${
                    user.avatar === "m" ? "потратил" : "потратила"
                }. Нужно научиться не только зарабатывать, но и накапливать, это
                поможет тебе в будущем.`,
            },
            action: {
                finalSum: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    icon: FinalIconLevel1,
                    descriptionText: "Итоги игры",
                },
                buttons: [
                    {
                        buttonText: "Далее",
                        linkOnStep: 135,
                    },
                ],
            },
        },
        135: {
            backButton: true,
            background: "glitters",
            preloadImg: [robot],
            nextLevel: 4,
            needAllMoney: true,
            action: {
                finalScreen: {
                    speakerImg: speakerData[user.avatar].imgAdultFull,
                    gender: user.avatar,
                    text: `Ты молодец! ${
                        user.avatar === "m" ? "Позаботился" : "Позаботилась"
                    } о своем будущем и ${
                        user.avatar === "m" ? "защитил" : "защитила"
                    }  свое благополучие! Так держать!`,
                },
                buttons: [
                    {
                        buttonText: "Закончить игру",
                        linkOnPage: "/",
                        linkOnStep: 135,
                    },
                ],
            },
        },
    };

    return data[stepNumber];
};
